import generateAdjustedEventTraits from 'src/js/modules/element-settings/helpers/generate-adjusted-event-traits';

const createAdjustedEventTraitsGetter =
  (optionNamePart) =>
  ({ eventTraitPrefix }) =>
    generateAdjustedEventTraits(eventTraitPrefix, optionNamePart);

export default createAdjustedEventTraitsGetter;
